<template>
  <el-container class="outer-container"
                v-if="showCpn">
    <el-header class="outheader">
      <TopHeader v-if="showTopHeader">
      </TopHeader>
      <EbayTopHeader v-if="ShowEbayTopHead">
      </EbayTopHeader>
    </el-header>
    <el-container class="inner-container">
      <el-aside class="inner-aside">
        <asideMenue></asideMenue>
      </el-aside>
      <el-container class="inner-container2">
        <el-header class="header">
          <template v-if="showNotice">
            <el-alert v-for="(item,index) in noticeMsg"
                      :key="item+index"
                      :title="item"
                      :closable="false"
                      :style="{width: 'calc(100% - 32px)',marginTop: '10px',marginBottom: '10px'}"
                      type="warning"
                      effect="dark"></el-alert>
          </template>
          <!-- <el-alert v-if="showNotice"
                    :title="noticeMsg"
                    :closable="false"
                    :style="{width: 'calc(100% - 32px)',marginTop: '10px',marginBottom: '10px'}"
                    type="warning"
                    effect="dark">
          </el-alert> -->
          <MainHeader v-if="showMainHeader">
          </MainHeader>
          <MainEbayHeader v-if="showMainEbayHeader">
          </MainEbayHeader>
          <MainPublicHeader v-if="showMainPublicHeader">
          </MainPublicHeader>
        </el-header>
        <el-main>
          <div style="width:100%">
            <router-view class="roterView" />
            <Footer v-if="!$store.state.user.loginInfo.is_partner">
            </Footer>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import asideMenue from '@/components/AsideMenue.vue'
import TopHeader from '@/components/topHeader.vue'
import EbayTopHeader from '@/components/topEbayHeader.vue'
import MainHeader from '@/components/mainHeader.vue'
import MainEbayHeader from '@/components/mainEbayHeader.vue'
import MainPublicHeader from '@/components/mainPublicHeader.vue'
import Footer from '@/components/footer.vue'
import { getDwNotice } from '@/api/public.js'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { getObjFromUrl } from '@/utils'
export default {
  components: {
    asideMenue,
    TopHeader,
    Footer,
    MainHeader,
    MainEbayHeader,
    EbayTopHeader,
    MainPublicHeader,
  },
  data() {
    return {
      showNotice: false,
      noticeMsg: [],
      showCpn: false,
    }
  },
  async created() {
    const browserFinger = localStorage.getItem('browserFinger')
    if (!browserFinger) {
      this.showCpn = false
      const fpPromise = FingerprintJS.load()
      const fp = await fpPromise
      const result = await fp.get()
      localStorage.setItem('browserFinger', result.visitorId)
      this.showCpn = true
    } else {
      this.showCpn = true
    }
  },
  mounted() {
    getDwNotice().then((res) => {
      if (res.result) {
        /**
         * result 示例: ["***","****"] 
         */
        if (res.result.length > 0) {
          const lang = localStorage.getItem('language')
          // if (lang == 'zh') {
          //   this.noticeMsg = res.result.msg
          // } else if (lang == 'en') {
          //   this.noticeMsg = res.result.msg_en
          // } else {
          //   this.noticeMsg = res.result.msg
          // }
          this.noticeMsg = res.result
          this.showNotice = true
        } else {
          this.noticeMsg = []
          this.showNotice = false
        }
      } else {
        this.noticeMsg = []
        this.showNotice = false
      }
    })
  },
  computed: {
    showMainHeader() {
      return this.$store.state.user.SHowMainHead
    },
    showMainEbayHeader() {
      return this.$store.state.user.ebayShowMainHead
    },
    showMainPublicHeader() {
      return this.$store.state.user.publicShowMainHead
    },
    showTopHeader() {
      return this.$store.state.user.SHowTopHead
    },
    ShowEbayTopHead() {
      return this.$store.state.user.ShowEbayTopHead
    },
    key() {
      return this.$route.name
        ? this.$route.name + this.$route.query.toString() + new Date().getTime()
        : this.$route + new Date().getTime()
    },
  },
}
</script>

<style scoped lang="less">
.el-header {
  padding-right: 0;
}
</style>
